import * as React from 'react';

import { cn, ConsoleTouchDialog, TouchTextField } from '@rematter/ui-web';
import { useAtom, useSetAtom } from 'jotai';
import { LucideTruck } from 'lucide-react';

import { $deleteEntry, $updateFreightCharge } from '../_state';
import { useDialogModalStyle } from '../hooks/useDialogModalStyle';

import { TouchDialogHeader } from './TouchDialogHeader';

import {
  $closeFreightDetails,
  $freightDetailsState,
} from '~/modules/trade/_state/materialsInterface.state';
import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { useTheme, useUIPreferences } from '~/shared/hooks';

//
// ⚛️ ⚛️ ⚛️ EDIT FREIGHT DIALOG ⚛️ ⚛️ ⚛️
//
export const EditFreightDialog = () => {
  // Translations
  const t = useTranslations();
  const labels = t.scaleTicketPro.freightDetails;

  // Atoms
  const [freightDetailsState, setFreightDetailsState] =
    useAtom($freightDetailsState);
  const closeFreightDetails = useSetAtom($closeFreightDetails);
  const updateFreightCharge = useSetAtom($updateFreightCharge);
  const deleteEntry = useSetAtom($deleteEntry);

  // Data hooks
  const { effectiveColorScheme } = useTheme();
  const { touchModeEnabled } = useUIPreferences();
  const modalStyle = useDialogModalStyle();

  const { isOpen, lineItemId, notes } = freightDetailsState;

  // Callbacks
  const handleDelete = React.useCallback(() => {
    if (!lineItemId) return;
    deleteEntry(lineItemId);
    closeFreightDetails();
  }, [lineItemId, deleteEntry, closeFreightDetails]);

  return (
    <ConsoleTouchDialog
      touchModeEnabled={touchModeEnabled}
      effectiveColorScheme={effectiveColorScheme}
      isOpen={isOpen}
      onOpenChange={closeFreightDetails}
      className="@EditFreightDialog"
      dialogClassName={cn('h-full w-full max-w-full')}
      contentStyle={modalStyle}
      header={
        <TouchDialogHeader
          icon={<LucideTruck size={16} />}
          iconColor="teal"
          title={labels.title}
          onDelete={handleDelete}
          deleteLabel={labels.delete}
        />
      }
    >
      <div className="p-4">
        <TouchTextField
          touchModeEnabled
          label={labels.fields.notes}
          value={notes ?? ''}
          onChange={(v) => {
            setFreightDetailsState((prev) => ({ ...prev, notes: v }));
            if (lineItemId)
              updateFreightCharge(lineItemId, { notes: v ?? null });
          }}
          rows={4}
        />
      </div>
    </ConsoleTouchDialog>
  );
};
